import {combineReducers} from 'redux';
import countrySlice from '../../pages/configuration/countries/redux/countrySlice';
import transactionSlice from '../../pages/finance/transaction/redux/transaction-slice';
import emailSlice from '../../pages/configuration/email-account/redux/emailSlice';
import subscriberSlice from 'src/pages/promotions/news-letter/subscribers/redux/subscriberSlice';

export let reducer = combineReducers({
  country: countrySlice,
  transaction: transactionSlice,
  email: emailSlice,
  subscriber: subscriberSlice,
});
